import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { FileUploader } from 'react-drag-drop-files';
import fileIcon from '../Assets/upload-icon.svg';
import doc from '../Assets/docx.png';
import { FileDownload, CloseRounded } from '@mui/icons-material';
import { downloadFileServer, postDatatoServer, uploadImageToServer } from '../utils/apiBase';
import toast from 'react-hot-toast';
import ContextHelper from '../ContextHooks/ContextHelper';
import { useLocation } from 'react-router-dom';
import DeleteModal from './DeleteModal';

function ReportDetailsModal(props) {
  const { closeModal, selectedReport, showModal, setUploadSuccess, setSelectedReport } = props;
  const { currentUser } = ContextHelper();
  const [mobileNumber, setMobileNumber] = useState('+91');
  const [locationData, setLocationData] = useState('');
  const [study, setStudy] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [file, setFile] = useState(null);
  const [getUploadImages, setGetUploadImages] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [verificationChanged, setVerificationChanged] = useState(false);
  const isVerifier = currentUser?.type === 'verifier';

  const location = useLocation();
  const path = location.pathname;
  const handleNumericInput = (e) => {
    let value = e.target.value;
    if (!value.startsWith('+91')) {
      value = '+91' + value.replace(/\D/g, '');
    } else {
      value = '+91' + value.substring(3).replace(/\D/g, '');
    }
    setMobileNumber(value);
    setErrorMessage('');
  };

  useEffect(() => {
    if (selectedReport?.contactNo === 'NA' || !showModal) {
      setErrorMessage('');
      setMobileNumber('+91');
      setFile(null);
      setGetUploadImages([]);
      setVerificationChanged(false);
    } else {
      setMobileNumber(selectedReport?.contactNo);
    }
  }, [selectedReport, showModal]);

  useEffect(() => {
    if (selectedReport?.location) {
      setLocationData(selectedReport.location);
    }
  }, [selectedReport]);

  useEffect(() => {
    if (selectedReport?.study) {
      setStudy(selectedReport.study);
    }
  }, [selectedReport]);

  const handleDeleteReport = () => {
    if (selectedReport.drRemark || selectedReport?.history || selectedReport.isUrgent || selectedReport.delete) {
      const requestBody = {
        id: selectedReport?.id,
        reportId: deleteId,
      };

      postDatatoServer({
        end_point: `deleteReport`,
        body: requestBody,
        call_back: (res) => {
          if (res?.status === 'success' && res?.response) {
            toast.success(res.response.message);
          } else {
            toast.error(res.response.message);
          }
          setUploadSuccess(true);
        },
        props: { header: true, token: currentUser?.token },
      });

      setDeleteModal(false);
    } else {
      return;
    }
  };

  const handleUpdateData = (item) => {
    if (
      selectedReport.drRemark ||
      selectedReport?.history ||
      selectedReport?.history ||
      selectedReport.isUrgent ||
      selectedReport.delete
    ) {
      const mobileNumberRegex = /^\+91\d{10}$/;
      if (!mobileNumber || !mobileNumberRegex.test(mobileNumber)) {
        setErrorMessage('Please enter a valid 10-digit Mobile number.');
      }

      const requestBody = {
        history: selectedReport.history,
        drRemark: selectedReport.drRemark,
        isUrgent: selectedReport.isUrgent,
        delete: selectedReport.delete,
        contactNo: mobileNumber,
      };

      postDatatoServer({
        end_point: `update/?id=${item.id}`,
        body: requestBody,
        call_back: (res) => {
          if (res?.status === 'success' && res?.response) {
            toast.success('Success');
            setUploadSuccess(true);
            closeModal();
          }
        },
        props: { header: true, token: currentUser?.token },
      });
    } else {
      return;
    }
  };

  const handleUpdateLocation = (item) => {
    const requestBody = {};

    if (currentUser?.type === 'superadmin') {
      requestBody.InstitutionName = locationData;
      requestBody.reportApproved = selectedReport.reportApproved;
    }

    if (currentUser?.type === 'admin' || currentUser?.type === 'Agent') {
      requestBody.InstitutionName = locationData;
      requestBody.reportApproved = selectedReport.reportApproved;
      if (study !== selectedReport?.study) {
        requestBody.studyDescription = study;
      }
    }

    // Only include isverifier in the payload if the verification status has changed
    if (isVerifier && verificationChanged) {
      requestBody.isverifier = selectedReport.isverifier;
    }

    postDatatoServer({
      end_point: `updateLocation/?id=${item.id}`,
      body: requestBody,
      call_back: (res) => {
        if (res?.status === 'success' && res?.response) {
          setUploadSuccess(true);
          closeModal();
        }
      },
      props: { header: true, token: currentUser?.token },
    });
  };

  const downloadFile = async (id) => {
    try {
      const response = await downloadFileServer({
        end_point: `getReport/${id}`,
        props: `report_${id}`,
      });
      console.log('File downloaded successfully:', response);
    } catch (error) {
      console.error('Error occurred during file download:', error);
    }
  };

  const downloadAttachFile = async (id) => {
    try {
      const response = await downloadFileServer({
        end_point: `getHistory/${id}`,
        props: `report_${id}`,
      });
    } catch (error) {
      console.log('Error occurred during file download:', error);
    }
  };

  const handleUploadImage = async (item, key) => {
    try {
      const endPoint = 'upload/history';

      const promisesArray = getUploadImages.map(async (file) => {
        const responseImage = await uploadImageToServer({
          end_point: `${endPoint}/?id=${item.id}`,
          data: file,
          props: item,
        });
        return responseImage;
      });

      const dataArray = await Promise.all(promisesArray);

      if (dataArray.length > 0) {
        setUploadSuccess(true);
        setGetUploadImages([]);
        setFile(null);
      }
      closeModal();
      toast.success('History uploaded successfully');
    } catch (err) {
      console.error('Error occurred during image upload:', err);
    }
  };

  const handleUploadReport = async (item, key) => {
    const formData = new FormData();
    formData.append('file', file);

    const templateData = {
      fileName: `${item.study}.pdf`,
      reportSource: 'supraviUi',
    };

    Object.entries(templateData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    postDatatoServer({
      end_point: `upload/reportNew/?id=${item.id}`,
      body: formData,
      call_back: handleApiResponse,
      props: { header: true, token: currentUser?.token },
    });
  };

  const handleApiResponse = (response) => {
    if (response?.status === 'success') {
      setFile(null);
      closeModal();
      toast.success('Report uploaded successfully');
    } else {
      throw new Error(response?.message || 'Upload failed');
    }
  };

  const handleReportStatusChange = (isApproved) => {
    setSelectedReport((prev) => ({
      ...prev,
      reportApproved: isApproved,
    }));
  };

  const handleRadioChange = (event) => {
    const { id, name } = event.target;
    setSelectedReport((prevSelectedReport) => {
      if (name.includes('urgent')) {
        return { ...prevSelectedReport, isUrgent: id === 'urgent-view1' || id === 'urgent1' };
      }
      if (name.includes('verifier')) {
        setVerificationChanged(true);
        return { ...prevSelectedReport, isverifier: id === 'verifier-view1' };
      }
      return prevSelectedReport;
    });
  };

  const handleHistoryChange = (event) => {
    const newHistory = event.target.value;
    // if (currentUser.historyUpdation || path === '/view-report') {
      setSelectedReport((prevSelectedReport) => ({
        ...prevSelectedReport,
        history: newHistory,
      }));
    // }
  };

  const handleTextareaChange = (event) => {
    const newDrRemark = event.target.value;
    setSelectedReport((prevSelectedReport) => ({
      ...prevSelectedReport,
      drRemark: newDrRemark,
    }));
  };

  const handleFileChange = (file) => {
    setFile(file);
    setGetUploadImages([file]);
  };

  const handleDeleteModal = (item, selectedReport) => {
    setDeleteId(item?.id);
    setSelectedReport(selectedReport);
    setDeleteModal(true);
    closeModal();
  };

  const handleSaveAll = async () => {
    const hasImages = getUploadImages.length > 0;

    try {
      if (hasImages) {
        if (path === '/view-report') {
          await handleUploadImage(selectedReport, 'report');
        } else {
          await handleUploadReport(selectedReport, 'report');
        }
      }

      await handleUpdateLocation(selectedReport);
      await handleUpdateData(selectedReport);
    } catch (error) {
      console.error('Save failed:', error);
      toast.error('Something went wrong while saving.');
    }
  };

  return (
    <>
      {(deleteModal && (
        <DeleteModal
          {...{
            deleteModal,
            closeModal: () => setDeleteModal(false),
            handleDeleteReport,
          }}
        />
      )) ||
        ''}
      {(showModal && (
        <Modal size="lg" show={showModal} onHide={closeModal} centered>
          <Modal.Header className="border-0" closeButton></Modal.Header>
          <Modal.Body className="pt-0">
            <h5>Report Details</h5>
            <div className="d-flex align-items-center my-2">
              <span className="fw-semibold me-2">Name:</span>
              <span>{selectedReport?.name}</span>
              <div className="ms-auto">
                <span className="fw-semibold me-2">Date:</span>
                <span>{moment(selectedReport?.date, 'D/M/YYYY, h:mm:ss a').format('DD MMMM YYYY, h:mm:ss a')}</span>
              </div>
            </div>
            <div className="d-flex align-items-center my-2">
              {currentUser?.permissions?.study_update === 'true' ||
              currentUser?.permissions?.study_update === true ||
              currentUser?.type === 'Agent' ? (
                <div>
                  <Form.Label>Study:</Form.Label>
                  <Form.Control type="text" value={study} onChange={(e) => setStudy(e.target.value)} />
                </div>
              ) : (
                <div>
                  <span className="fw-semibold me-2">Study:</span>
                  <span>{selectedReport?.study}</span>
                </div>
              )}

              <Form.Group controlId="formMobileNumber" className="ms-auto">
                <div className="d-flex align-items-center text-nowrap gap-2">
                  <Form.Label> Patient Mobile:</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your mobile number"
                    value={mobileNumber}
                    maxLength={13}
                    onChange={handleNumericInput}
                    isInvalid={!currentUser?.isadmin && !!errorMessage}
                    disabled={currentUser?.isadmin}
                  />
                </div>

                {!currentUser?.isadmin && errorMessage && (
                  <Form.Control.Feedback type="invalid" className="d-block mt-1">
                    {errorMessage}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </div>
            {currentUser?.type === 'superadmin' && (
              <div className="d-flex align-items-center my-2">
                <Form.Group controlId="formMobileNumber" className="ms-auto">
                  <div className="d-flex align-items-center gap-2 text-nowrap">
                    <Form.Label>Location:</Form.Label>
                    <Form.Control type="text" value={locationData} onChange={(e) => setLocationData(e.target.value)} />
                  </div>
                </Form.Group>
              </div>
            )}

            <div className="my-4">
              <p className="fw-semibold me-2 mb-2">History:</p>
              <Form.Control
                as="textarea"
                readOnly={
                  !(
                    currentUser?.permissions?.history_update === 'true' ||
                    currentUser?.permissions?.history_update === true ||
                    currentUser?.type === 'Agent'
                  )
                }
                value={selectedReport?.history}
                onChange={handleHistoryChange}
              />
            </div>
            {path === '/view-report' && <p className="fw-semibold me-2 mb-2">Upload Study:</p>}
            <div className="d-flex">
              {(path === '/view-report' && (
                <>
                  <div className="w-50">
                    <FileUploader
                      multiple={false}
                      handleChange={handleFileChange}
                      label={file ? file.name : 'Drag & Drop to Upload Document'}
                      name="file"
                      classes="drag-area rounded-3 flex-column d-flex justify-content-center align-items-center me-4"
                    >
                      <div className="icon">
                        <img src={fileIcon} alt="Upload" />
                      </div>
                      <p className="my-2">Drag & Drop to Upload Study</p>
                      <span className="or">OR</span>
                      <Button variant="" className="login-btn base-color-bg text-white fw-semibold mt-4">
                        Browse Report
                      </Button>
                      {file && <p className="fs-16 mb-0 mt-3">{file.name || ''}</p>}
                    </FileUploader>
                  </div>
                </>
              )) ||
                ''}

              <div className="d-flex flex-wrap">
                {selectedReport?.historyFiles.length > 0 &&
                  selectedReport.historyFiles.map((item, key) => (
                    <div key={key} className="me-4 position-relative icon-docs">
                      {(!currentUser?.isadmin && (
                        <CloseRounded
                          onClick={() => handleUpdateData(selectedReport)}
                          className="position-absolute cursor-pointer text-danger d-none close-icon ms-4"
                        />
                      )) ||
                        ''}
                      <img
                        src={doc}
                        alt="report"
                        className="img-fluid"
                        width={70}
                        onClick={() => downloadAttachFile(item.uri)}
                      />
                      <div className="mt-3 text-center cursor-pointer" onClick={() => downloadAttachFile(item.uri)}>
                        <FileDownload className="base-color" />
                      </div>
                    </div>
                  ))}
              </div>
            </div>

            <div className="d-flex align-items-center gap-4 mb-2">
              {(isVerifier && (
                <div className="d-flex">
                  <span className="fw-semibold me-2">Verifier:</span>
                  <div className="form-check me-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="verifier-1"
                      id="verifier-view1"
                      checked={selectedReport?.isverifier === true}
                      onChange={handleRadioChange}
                    />
                    <label className="form-check-label cursor-pointer" htmlFor="verifier-view1">
                      Yes
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="verifier-2"
                      id="verifier-view2"
                      checked={selectedReport?.isverifier === false}
                      onChange={handleRadioChange}
                    />
                    <label className="form-check-label cursor-pointer" htmlFor="verifier-view2">
                      No
                    </label>
                  </div>
                </div>
              )) ||
                ''}

              {(path === '/view-report' && (
                <div className="d-flex my-3">
                  <span className="fw-semibold me-2">Urgent:</span>
                  <div className="form-check me-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="urgent-1"
                      id="urgent-view1"
                      checked={selectedReport?.isUrgent === true}
                      onChange={handleRadioChange}
                    />
                    <label className="form-check-label cursor-pointer" htmlFor="urgent-view1">
                      Yes
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="urgent-2"
                      id="urgent-view2"
                      checked={selectedReport?.isUrgent === false}
                      onChange={handleRadioChange}
                    />
                    <label className="form-check-label cursor-pointer" htmlFor="urgent-view2">
                      No
                    </label>
                  </div>
                </div>
              )) || (
                <div className="d-flex gap-4">
                  <div className="d-flex">
                    <span className="fw-semibold me-2">Urgent:</span>
                    <div className="form-check me-3">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="urgent"
                        id="urgent1"
                        checked={selectedReport?.isUrgent === true}
                      />
                      <label className="form-check-label cursor-pointer" htmlFor="urgent1">
                        Yes
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="urgent"
                        id="urgent2"
                        checked={selectedReport?.isUrgent === false}
                      />
                      <label className="form-check-label cursor-pointer" htmlFor="urgent2">
                        No
                      </label>
                    </div>
                  </div>
                  {(currentUser?.isadmin && currentUser?.type === 'admin' && (
                    <>
                      {(currentUser?.permissions?.report_approval === 'true' ||
                        currentUser?.permissions?.report_approval === true) && (
                        <div className="d-flex">
                          <span className="fw-semibold me-2">Report Status:</span>

                          <div className="form-check me-3">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="reportStatus"
                              id="reportStatus1"
                              onChange={() => handleReportStatusChange(true)}
                              checked={selectedReport?.reportApproved === true}
                            />
                            <label className="form-check-label cursor-pointer" htmlFor="reportStatus1">
                              Approved
                            </label>
                          </div>

                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="reportStatus"
                              id="reportStatus2"
                              onChange={() => handleReportStatusChange(false)}
                              checked={selectedReport?.reportApproved === false}
                            />
                            <label className="form-check-label cursor-pointer" htmlFor="reportStatus2">
                              Unapproved
                            </label>
                          </div>
                        </div>
                      )}
                    </>
                  )) ||
                    ''}
                </div>
              )}
            </div>
            <p className="fw-semibold me-2 mb-2">Dr Remark:</p>
            {(path === '/add-report' && (
              <Form.Control as="textarea" value={selectedReport?.drRemark} onChange={handleTextareaChange} />
            )) || <Form.Control as="textarea" value={selectedReport?.drRemark} />}
            {(!currentUser?.isadmin && !selectedReport.reportApproved) || (
                <p className="fw-semibold me-2 my-2">Upload Report :</p>
              ) ||
              ''}
            <div className="d-flex text-nowrap align-items-center mt-3 flex-wrap gap-4">
              {(path === '/add-report' && (
                <div className="w-50">
                  <FileUploader
                    multiple={false}
                    handleChange={handleFileChange}
                    label={file ? file.name : 'Drag & Drop to Upload Document'}
                    name="file"
                    classes="drag-area rounded-3 flex-column d-flex justify-content-center align-items-center"
                  >
                    <div className="icon">
                      <img src={fileIcon} alt="Upload" />
                    </div>
                    <p className="my-2">Drag & Drop to Upload Report</p>
                    <span className="or">OR</span>
                    <Button variant="" className="login-btn base-color-bg text-white fw-semibold mt-4">
                      Browse Report
                    </Button>
                    {file && <p className="fs-16 mb-0 mt-3">{file.name || ''}</p>}
                  </FileUploader>
                </div>
              )) ||
                ''}
              {selectedReport?.reports.length > 0 &&
                selectedReport.reports.map((item, key) => (
                  <div key={key} className="position-relative icon-docs">
                    {(currentUser?.isadmin && (
                      <CloseRounded
                        onClick={() => handleDeleteModal(item, selectedReport)}
                        className="position-absolute cursor-pointer text-danger d-none close-icon ms-4"
                      />
                    )) ||
                      ''}
                    {(!currentUser?.isadmin && !selectedReport.reportApproved) || (
                      <>
                        <img
                          src={doc}
                          alt="report"
                          className="img-fluid"
                          width={70}
                          onClick={() => downloadFile(item.uri)}
                        />

                        <div className="mt-3 text-center cursor-pointer" onClick={() => downloadFile(item.uri)}>
                          <FileDownload className="base-color" />
                        </div>
                      </>
                    )}
                  </div>
                ))}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant=""
              onClick={() => {
                if (getUploadImages.length === 0) {
                  handleUpdateLocation(selectedReport);
                  if (path === '/view-report') {
                    handleUpdateData(selectedReport);
                  } else {
                    handleUpdateData(selectedReport);
                  }
                } else {
                  if (path === '/view-report') {
                    handleUploadImage(selectedReport, 'report');
                  } else {
                    handleUploadReport(selectedReport, 'report');
                  }
                }
              }}
              className="login-btn base-color-bg text-white fw-semibold ms-auto"
              disabled={path === '/view-report' && selectedReport?.history.length === 0}
            >
              Save
            </Button>

            <Button variant="secondary" onClick={closeModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )) ||
        ''}
    </>
  );
}

export default ReportDetailsModal;
